'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DocumentModeCanvasElementDebugger = require('./DocumentModeCanvasElementDebugger');

var _DocumentModeCanvasElementDebugger2 = _interopRequireDefault(_DocumentModeCanvasElementDebugger);

var _DocumentModeCanvasReadingLineDebugger = require('./DocumentModeCanvasReadingLineDebugger');

var _DocumentModeCanvasReadingLineDebugger2 = _interopRequireDefault(_DocumentModeCanvasReadingLineDebugger);

require('./DocumentModeCanvasColumnDebugger.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getColumnBorderStyle = function getColumnBorderStyle(gridSize, columnData) {
    var bounds = columnData.getIn(['cluster', 'bounds']).toJS();

    return {
        top: bounds.top * gridSize,
        left: bounds.left * gridSize,
        width: (bounds.right - bounds.left) * gridSize,
        height: (bounds.bottom - bounds.top) * gridSize
    };
};

var DocumentModeCanvasColumnDebugger = function DocumentModeCanvasColumnDebugger(_ref) {
    var gridSize = _ref.gridSize,
        clusterIndex = _ref.clusterIndex,
        columnIndex = _ref.columnIndex,
        columnData = _ref.columnData,
        elementOrder = _ref.elementOrder;

    var columnReadingLines = columnData.get('readingData');
    var elementsData = columnData.get('children');

    return _react2.default.createElement(
        'div',
        { className: 'DocumentModeCanvasColumnDebugger' },
        _react2.default.createElement('div', { className: 'column-border', style: getColumnBorderStyle(gridSize, columnData) }),
        elementsData.map(function (clusterData, index) {
            return _react2.default.createElement(_DocumentModeCanvasElementDebugger2.default, {
                key: index,
                gridSize: gridSize,
                clusterIndex: clusterIndex,
                columnIndex: index + 1,
                elementClusterData: clusterData,
                elementOrder: elementOrder });
        }),
        columnReadingLines.map(function (readingLine, index) {
            return _react2.default.createElement(_DocumentModeCanvasReadingLineDebugger2.default, _extends({
                className: 'element',
                key: index,
                gridSize: gridSize,
                order: index + 1
            }, readingLine.toJS()));
        })
    );
};

DocumentModeCanvasColumnDebugger.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    clusterIndex: _propTypes2.default.number.isRequired,
    columnIndex: _propTypes2.default.number.isRequired,
    columnData: _propTypes2.default.object.isRequired,
    elementOrder: _propTypes2.default.object.isRequired
};

exports.default = DocumentModeCanvasColumnDebugger;


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/DocumentModeCanvasColumnDebugger.js
// module id = 1941
// module chunks = 0